import { render, staticRenderFns } from "./ChallengeDialogAbort.vue?vue&type=template&id=230fc453"
import script from "./ChallengeDialogAbort.vue?vue&type=script&lang=ts"
export * from "./ChallengeDialogAbort.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports